import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { useContent } from "../../context/ContentContext";

export default function Footer() {
  const { t } = useContent();
  return (
    <footer className="bg-[#0B192C] text-slate-300" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/rospa-logo.png" alt="Rospa Advanced Drivers and Riders" className="h-10 w-10 object-contain shrink-0" />
              <div className="leading-tight">
                <div className="text-white font-heading font-extrabold text-sm">Rospa Advanced Drivers and Riders</div>
                <div className="text-amber-400 text-[10px] tracking-[0.2em] font-semibold">WEST MIDLANDS</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              {t("footer.tagline", "Helping members raise their roadcraft, stay safer and enjoy the road since 1999.")}
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Get started</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/riders" className="hover:text-amber-400">Advanced Riders</Link></li>
              <li><Link to="/drivers" className="hover:text-amber-400">Advanced Drivers</Link></li>
              <li><Link to="/certification" className="hover:text-amber-400">Test & Certification</Link></li>
              <li><Link to="/join" className="hover:text-amber-400">Join the Club</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Club</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/events" className="hover:text-amber-400">Events</Link></li>
              <li><Link to="/news" className="hover:text-amber-400">News</Link></li>
              <li><Link to="/gallery" className="hover:text-amber-400">Gallery</Link></li>
              <li><Link to="/about" className="hover:text-amber-400">About us</Link></li>
              <li><Link to="/login" className="hover:text-amber-400">Member Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 mt-0.5 text-amber-400" />
                <a href="mailto:enquiries@rospabikers.club" className="hover:text-amber-400">enquiries@rospabikers.club</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-amber-400" />
                <span>West Midlands, United Kingdom</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} RoSPA Advanced Drivers and Riders, West Midlands.</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 justify-center">
            <Link to="/privacy" className="hover:text-amber-400">Privacy</Link>
            <Link to="/accessibility" className="hover:text-amber-400">Accessibility</Link>
            <Link to="/terms" className="hover:text-amber-400">Terms of use</Link>
            <Link to="/safeguarding" className="hover:text-amber-400">Safeguarding</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
